<template>
  <div class="login container">
    <div class="row">
    <h1>Login Ludo Map</h1>
    </div>
    <div class="row">
      <div class="col-md-8">
      <div class="form-group">
        <input type="text" name="username" class="form-control" v-model="input.username" placeholder="Gebruikersnaam" />
      </div>
      <div class="form-group">
        <input type="password" name="code" class="form-control" v-model="input.code" placeholder="Code" />
      </div>
      <div v-if='error' class="form-group">
        {{error}}
      </div>
      <button type="button" class="btn btn-primary mb-2" v-on:click="login()">Login</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      input: {
        username: "",
        password: ""
      },
      error: false
    }
  },
  methods: {
    login() {
      if(this.input.username != "" && this.input.code != "") {
        this.$http.post("https://server.ludodidactiek.soft-ice.nl/auth/login", this.input, { headers: { "content-type": "application/json" } }).then(() => {
            window.loggedIn = true
            if(this.input.username === 'admin'){
              this.$router.replace({ name: "admin" });
            } else {
              this.$router.replace({ name: "map" });

            }
        }, (error) => {
          console.log("ERROR", error) //eslint-disable-line
          this.error = "De gebruikersnaam of de code is niet correct";
        })
      }
    }
  }
}
</script>

<style>
  .col-md-8 {
    text-align: left;
  }
</style>
